export default "__VITE_ASSET__BWYlGFpX__"